import { AppConfigurator } from '@/app/layout/components/app.configurator';
import { LayoutService } from '@/app/layout/service/layout.service';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-notfound',
    standalone: true,
    imports: [RouterModule, ButtonModule, AppConfigurator],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './notfound.html'
})
/* v8 ignore start */
export class Notfound {
/* v8 ignore stop */
    layoutService = inject(LayoutService);
}
